import { render, staticRenderFns } from "./notification_snackbar.vue?vue&type=template&id=a3b520f6&"
import script from "./notification_snackbar.vue?vue&type=script&lang=ts&"
export * from "./notification_snackbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports